import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import AppLayout from "../../../layouts/AppLayout";
import { ReactNode, useEffect, useState } from "react";
import {
  getHouseIdFromToken,
  getParentIdFromToken,
  fetchBalance,
  useAppDispatch,
  useAppSelector,
  ACCEPT_TERMS_ROUTE,
  ACCESS_REDIRECT_ROUTE,
  FORGOT_PASSWORD_ROUTE,
  LOGIN_ROUTE,
  SIGN_UP_ROUTE,
  SPORTS_BOOK_ROUTE,
  getDomainConfig,
  HOME_ROUTE,
  RESET_PASSWORD_ROUTE,
  IN_PLAY_ROUTE,
  APP_ROUTE,
  getAdminWhatsAppNumber,
} from "@hypexone/uicore";
import { BRAND_DOMAIN } from "../../../constants/Branding";
import { pnService } from "../../../webSocket/SocketServices";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import HomePage from "../../pages/HomePage";
import ForgotPassword from "../../pages/ForgotPassword/ForgotPassword";
import MobileLoginPage from "../../pages/MobileLoginPage";
import NoAccessPage from "../../pages/NoAccessPage";
import ResetPassword from "../../pages/ResetPassword/ResetPassword";
import AuthSignUp from "../../pages/Register";
import CasinoIFrame from "../iframes/CasinoIFrame";
import SportsbookIFrame from "../iframes/SportsbookIFrame";
import RegisterPage from "../../pages/SignUpPage";
import ResendVerificationEmail from "../../pages/ResendEmail";
import Maintenance from "../../pages/Maintenance";
import { IoCloseCircleSharp } from "react-icons/io5";
import { useWhatsappLink } from "../../../utils/hooks/useWhatsappLink.hooks";
import CustomerSupport from "../../../assets/icons/customer-support.svg?react";
// import MaintenanceWrapper from "../../../components/MaintenanceWrapper";

export const MAINTENANCE_ROUTE = "/maintenance";

const WhatsappSupportButton = () => {
  const location = useLocation();
  const [showWhatsapp, setShowWhatsapp] = useState(true);
  const { whatsappLink } = useWhatsappLink();
  const { domainConfig } = useAppSelector((state) => state.common);

  const isAllowedRoute =
    location.pathname === APP_ROUTE ||
    location.pathname.includes(HOME_ROUTE) ||
    location.pathname.includes(IN_PLAY_ROUTE);

  if (
    !domainConfig.whatsapp ||
    !domainConfig.b2cEnabled ||
    !showWhatsapp ||
    !isAllowedRoute
  ) {
    return null;
  }

  return (
    <div className="fixed bottom-[60px] md:bottom-4 right-4 z-10">
      <CustomerSupport
        className="w-12 md:w-14"
        onClick={() => window.open(whatsappLink, "_blank")}
      />
      <IoCloseCircleSharp
        size={"20"}
        className="absolute md:top-0 md:right-0 top-[-6px] right-[-6px]"
        onClick={(e) => {
          e.stopPropagation();
          setShowWhatsapp(false);
        }}
      />
    </div>
  );
};

const rootLevelRoutes: { path: string; component: ReactNode }[] = [
  {
    path: LOGIN_ROUTE,
    component: <MobileLoginPage />,
  },
  {
    path: SIGN_UP_ROUTE,
    component: <RegisterPage />,
  },
  {
    path: "/resend-email",
    component: <ResendVerificationEmail />,
  },
  {
    path: FORGOT_PASSWORD_ROUTE,
    component: <ForgotPassword />,
  },
  {
    path: "/emailSignup",
    component: <AuthSignUp />,
  },
  {
    path: ACCEPT_TERMS_ROUTE,
    component: <ResetPassword />,
  },
  {
    path: RESET_PASSWORD_ROUTE,
    component: <ResetPassword />,
  },
  {
    path: ACCESS_REDIRECT_ROUTE,
    component: <NoAccessPage />,
  },
  {
    path: "/dc/gamev1.1/:gamePath",
    component: <CasinoIFrame />,
  },
  {
    path: SPORTS_BOOK_ROUTE,
    component: <SportsbookIFrame />,
  },
  {
    path: MAINTENANCE_ROUTE,
    component: <Maintenance />,
  },
  {
    path: HOME_ROUTE,
    component: <HomePage />,
  },
  {
    path: "/",
    component: <Navigate to="/home" replace />,
  },
];
const AppRoutes = () => {
  const dispatch = useAppDispatch();
  const { loggedIn, balanceSummary } = useAppSelector((state) => state.auth);
  const { balanceChanged } = useAppSelector((state) => state.common);
  const { pushNotifWSConnection } = useAppSelector((state) => state.catalog);

  const houseId = getHouseIdFromToken();
  const parentId = getParentIdFromToken();
  const accountId = sessionStorage.getItem("aid");

  useEffect(() => {
    if (loggedIn) {
      if (pushNotifWSConnection) {
        pnService.disconnectFromPushNotificationWS();
      }
      pnService.connectToPushNotification();
    }

    return () => {
      if (pushNotifWSConnection) {
        pnService.disconnectFromPushNotificationWS();
      }
    };
  }, [loggedIn]);

  useEffect(() => {
    if (
      loggedIn &&
      !window.location.pathname.includes("==") &&
      !window.location.pathname.includes("multi-markets") &&
      pushNotifWSConnection
    ) {
      pnService.subscribeWsForNotifications(false, houseId);
      pnService.subscribeWsForNotificationsPerAdmin(
        false,
        houseId,
        parentId,
        accountId
      );
    }
  }, [pushNotifWSConnection, loggedIn]);

  useEffect(() => {
    if (loggedIn) {
      dispatch(fetchBalance());
    }
  }, [loggedIn, balanceChanged]);

  useEffect(() => {
    if (loggedIn && balanceSummary?.balance) {
      if (
        localStorage.getItem("campaignId") &&
        localStorage.getItem("balance") &&
        localStorage.getItem("balance") != balanceSummary?.balance
      ) {
        // depositEvent();
        localStorage.removeItem("balance");
        localStorage.removeItem("campaignId");
      }
    }
  }, [balanceSummary?.balance]);

  useEffect(() => {
    dispatch(getDomainConfig(BRAND_DOMAIN));
    if (loggedIn) {
      dispatch(getAdminWhatsAppNumber(BRAND_DOMAIN));
    }
  }, [loggedIn]);

  return (
    <BrowserRouter>
      {/* <MaintenanceWrapper> */}
      <Routes>
        {rootLevelRoutes.map((route, index) => (
          <Route key={index} path={route.path} element={route.component} />
        ))}
        <Route key={"login"} path="*" Component={AppLayout} />
      </Routes>
      {/* </MaintenanceWrapper> */}
      <WhatsappSupportButton />
    </BrowserRouter>
  );
};

export default AppRoutes;
